export default [
  {
    text: "2022年四季度“两率”",
    url: "/pdf/getelectrictZl/2022年四季度”两率“.pdf",
  },
  {
    text: "2022年三季度“两率”",
    url: "/pdf/getelectrictZl/2022年三季度“两率”.pdf",
  },
  {
    text: "2022年二季度“两率”",
    url: "/pdf/getelectrictZl/2022年二季度“两率”.pdf",
  },
  {
    text: "2022年一季度“两率”",
    url: "/pdf/getelectrictZl/2022年一季度“两率”.pdf",
  },
  {
    text: "2021年四季度“两率”",
    url: "/pdf/getelectrictZl/2021年四季度“两率”.pdf",
  },
  {
    text: "2021年三季度“两率”",
    url: "/pdf/getelectrictZl/2021年三季度“两率”.pdf",
  },
  {
    text: "2021年二季度“两率”",
    url: "/pdf/getelectrictZl/2021年二季度“两率”.pdf",
  },
  {
    text: "2021年一季度“两率”",
    url: "/pdf/getelectrictZl/2021年一季度“两率”.pdf",
  },
  {
    text: "2020年四季度“两率”",
    url: "/pdf/getelectrictZl/2020年四季度“两率”.pdf",
  },
  {
    text: "2020年三季度“两率”",
    url: "/pdf/getelectrictZl/2020年三季度“两率”.pdf",
  },
  {
    text: "2020年二季度“两率”",
    url: "/pdf/getelectrictZl/2020年二季度“两率”.pdf",
  },
  {
    text: "2020年一季度“两率”",
    url: "/pdf/getelectrictZl/2020年一季度“两率”.pdf",
  },
];
